const { chunk, pickBy, get, omit, pick, isEmpty } = require('lodash');
const { addDays, } = require('date-fns');

const { idWithTenant } = require('../util');

const { entries } = Object;

const fields = ({ products } = {}) => {
  return {
    name: {
      label: '加工組名',
      type: 'string',
      validations: {
        required: _ => !isEmpty(_),
      },
    },
  };
};

// NOTE: 旧データ（combinedProductIdの単一）と新データ（combinedItemsの配列）の両方に対応
const getCombinedItems = (combiningTemplate = {}) => {
  const { combinedItems, combinedProductId, } = combiningTemplate;
  if(!isEmpty(combinedItems)) return combinedItems;
  if(combinedProductId != null) return [{ productId: combinedProductId, quantity: 1, }];
  return [];
};

module.exports = {
  itemFields: ({ items = [], products = [], } = {}) => {
    return {
      productId: {
        label: '商品',
        type: 'select',
        options: products.map(_ => ({ label: `${idWithTenant(_.ref)} [${_.sku}] ${_.name}`, value: _.id })),
        validations: {
          required: _ => !isEmpty(_),
          unique: v => items.filter(_ => _.productId === v).length < 2,
        },
        hint: '商品ID、SKU、ASINで検索できます',
      },
      quantity: {
        label: '1加工あたりの数量',
        type: 'integer',
        validations: {
          greaterThan0: _ => _ > 0,
        },
      },
    };
  },
  combinedItemFields: ({ items = [], products = [], } = {}) => {
    return {
      productId: {
        label: '完成商品',
        type: 'select',
        options: products.map(_ => ({ label: `${idWithTenant(_.ref)} [${_.sku}] ${_.name}`, value: _.id })),
        validations: {
          required: _ => !isEmpty(_),
          unique: v => items.filter(_ => _.productId === v).length < 2,
        },
        hint: '商品ID、SKU、ASINで検索できます',
      },
      quantity: {
        label: '1加工あたりの完成数量',
        type: 'integer',
        validations: {
          greaterThan0: _ => _ > 0,
        },
      },
    };
  },
  fields,
  getCombinedItems,
};
